import React from "react"

import { MainContainer } from "components/main-container"
import { H2 } from "components/text"
import Grid, { Col } from "components/grid"
import { Toolbar, NotificationPicker, DashboardCard } from "./components"

import { useAssertValidRootQuery } from "graphql/smart-queries/user"
import { NextActionEnum, SubscriptionStatusEnum, JourneyKindEnum, DrugTypeEnum } from "typings/types"
import { baseRoutes } from "routes"
import { maybeGetActiveJourney } from "shared/user/helpers"
import { flatten } from "lodash"

const Dashboard = () => {
  const {
    user,
    user: { consultation, activeSubscriptions, subscriptions, coveMigraineEventsThisMonthCount }
  } = useAssertValidRootQuery()

  const activeJourneyApproveTreatmentNext = maybeGetActiveJourney(user, NextActionEnum.ApproveTreatment)
  const activeJourney = maybeGetActiveJourney(user)
  const hasNonCanceledSubscriptions = subscriptions.filter(s => s.status !== SubscriptionStatusEnum.Canceled).length > 0
  const hasActiveSubscriptions = activeSubscriptions.length > 0

  const showDoctorMessagePageItem =
    consultation?.doctor && (activeJourney?.kind === JourneyKindEnum.CovePurchase || hasNonCanceledSubscriptions)
  const showTreatmentPageItem = activeJourneyApproveTreatmentNext || hasActiveSubscriptions

  const activeSubscriptionProducts = flatten(activeSubscriptions.map(s => s.activeProducts))
  const activeSubscriptionProductsFilteredCount = activeSubscriptionProducts.filter(
    p => p.drugType !== DrugTypeEnum.MedicalFee
  ).length

  return (
    <MainContainer
      mainContent={
        <>
          <Toolbar doctorExists={!!consultation?.doctor} />
          <Grid rowProps={{ justifyContent: "center" }} pt={8} pb={7} noGutter>
            <Col cols={[4, 4, 9, 9]}>
              <H2>Welcome, {user.firstName}</H2>

              <NotificationPicker />

              {consultation && (
                <>
                  {showDoctorMessagePageItem && consultation.doctor && (
                    <DashboardCard
                      title="Doctor messages"
                      subtitle={`${
                        consultation.unreadDoctorMessagesCount === 1 ? "new message" : "new messages"
                      } from your doctor.`}
                      rightLinkIcon="message"
                      rightLinkText="Send message"
                      rightLinkTo={baseRoutes.doctorMessaging()}
                      bottomLinkTo={baseRoutes.doctorMessaging()}
                      bottomLinkText="See all messages"
                      showNotification={consultation.unreadDoctorMessagesCount > 0}
                      count={consultation.unreadDoctorMessagesCount}
                    />
                  )}
                  {showTreatmentPageItem && (
                    <DashboardCard
                      title="Treatment Plan"
                      subtitle={`${
                        activeSubscriptionProductsFilteredCount === 1 ? "medication" : "medications"
                      } in your plan.`}
                      rightLinkIcon="adjust"
                      rightLinkText="View plan"
                      rightLinkTo={baseRoutes.treatmentPlan()}
                      bottomLinkTo={baseRoutes.treatmentPlan()}
                      bottomLinkText="See more"
                      count={activeSubscriptionProductsFilteredCount}
                    />
                  )}
                </>
              )}

              <DashboardCard
                title="My migraine management"
                subtitle={`${coveMigraineEventsThisMonthCount === 1 ? "event " : "events"} this month.`}
                rightLinkIcon="plus"
                rightLinkText="Add event"
                rightLinkTo={baseRoutes.migraineEventsNew()}
                bottomLinkTo={baseRoutes.progressTracking()}
                bottomLinkText="See more"
                count={coveMigraineEventsThisMonthCount}
              />
            </Col>
          </Grid>
        </>
      }
    />
  )
}

export default Dashboard
